// Information the Search Agent can collect from a lead during a conversation
// (Setup > Search > General > Search Experience > Search Agent).
//
// The ids are a persisted wire contract, not display strings: they are stored verbatim on the user,
// forwarded to Kestrel, and consumed unmapped by the search agent. Renaming one breaks those
// consumers, so keep them stable and independent of the labels.
class Type {
	public static LOCATION = new Type("location", "Location");
	public static PROPERTY_TYPE = new Type("propertyType", "Property Type");
	public static BEDS_BATHS = new Type("bedsBaths", "Bedrooms / Bathrooms");
	public static PRICE_RANGE = new Type("priceRange", "Price Range");
	public static TIMELINE = new Type("timeline", "Timeline");
	public static PRE_APPROVAL = new Type("preApproval", "Mortgage Pre-approval Status");

	private constructor(
		public readonly id: string,
		public readonly label: string
	) {}

	public static values(): Type[] {
		return Object.values(Type);
	}

	public static getById(id?: string) {
		return this.values().find((value) => value.id === id);
	}
}

export { Type as SearchAgentCaptureFieldType };
